import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack, Typography } from '@lyearn/ui';
import { Image } from '@/components/Image';

import { AuthorProps } from './types';

const Author: React.FC<AuthorProps> = (props) => {
  const { name, createdAt, picture } = props;
  const { t } = useTranslation();

  return (
    <Stack className="mt-40 xs:px-18" direction="col">
      <Typography className="text-text-primary mb-16 text-[16px] " numberOfLines={1}>
        {t('Course:Author')}
      </Typography>
      <Stack>
        <Image
          alt={name}
          className="h-48 w-48 rounded-full border border-border"
          height={48}
          objectFit="contain"
          src={picture}
          width={48}
        />
        <Stack className="ms-16" direction="col">
          <Typography className="text-text-primary" numberOfLines={1} variant="body-short-01">
            {name}
          </Typography>
          <Typography className="text-text-secondary text-[14px]" numberOfLines={1}>
            {createdAt}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default React.memo(Author);
